module.exports = __webpack_public_path__ + "static/media/camper_op_de_camping.409a10e5.jpg";